"use client";

import Image from "next/image";
import * as images from "@/components/images/Images";
import { cn } from "@/lib/utils";
import { memo, useState } from "react";
import { IndustryCTAProps } from "./types";
import { Typography } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { ROUTES } from "@/constants";

const IndustryCTA = ({ className }: IndustryCTAProps) => {
  return (
    <section
      className={cn("section bg-blue-800 py-[72] lg:py-[45]", className)}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-6 place-content-start text-center sm:text-left sm:flex sm:items-center sm:gap-8 md:gap-[min(26px,1.8vw)]">
          <div className="rounded-full p-14 border border-white w-[301] h-[301] flex items-center justify-center bg-[rgba(91,150,244,0.2)] mx-auto sm:mx-0 shrink-0">
            <div className="inline-flex items-center justify-center flex-auto min-w-0 overflow-hidden">
              <Image
                src={images.womanIndustry}
                alt="Languex industry CTA"
                width={372}
                height={373}
                className="flex-auto min-w-0 object-cover"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6 place-content-start md:flex md:items-center md:gap-[min(32px,2.2vw)]">
            <div className="flex-auto min-w-0">
              <Typography variant="heading5" className="text-white" asChild>
                <h3>
                  We match your project with expert translators vetted for your
                  industry and language pair
                </h3>
              </Typography>
            </div>
            <div className="flex">
              <Button
                asChild
                variant="primary-outline"
                className="bg-white py-3 px-6 h-[48px] lg:!px-[55.5px] w-full sm:w-auto lg:h-[84px] lg:rounded-[64px]"
              >
                <Link
                  href={ROUTES.startOrder}
                  className="!text-base lg:!text-2xl lg:!font-semibold"
                >
                  Start order
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(IndustryCTA);
